// extracted by mini-css-extract-plugin
module.exports = {"JPEG":"JPEG_JPEG__385rL","JPEGAlgorithm":"JPEG_JPEGAlgorithm__2PumD"};